import React from "react";
import PropTypes from "baobab-react/prop-types";
import { branch } from "baobab-react/higher-order";
import autoBind from "react-autobind";
import FontAwesome from "react-fontawesome";

//Placeholder
class ActivityPlayerShowModeToolbar extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	onClickPlay() {
		if (this.props.onClickPlay) {
			this.props.onClickPlay();
		}	
	}

	onClickComments() {
		if (this.props.onClickComments) {
			this.props.onClickComments();
		}	
	}

	onClickClose() {
		if (this.props.onClickClose) {
			this.props.onClickClose();
		}
	}

	render() {	

		let playButton = (this.props.showPlayButton) ? <div className="player-show-mode-toolbar-button" onClick={this.onClickPlay}>
			<FontAwesome name="play-circle-o" />
		</div> : null;

		let showExitButton = true;
		if (this.props.persistenceType.toLowerCase() === "default" && this.props.navStack.length === 0) {
			showExitButton = false;
		}

		return (
			<div className="player-show-mode-toolbar-container">
				<div style={{ display: "flex", flexDirection: "row" }}>
					{playButton}
					{this.props.showComments &&
					<div className="player-show-mode-toolbar-button" onClick={this.onClickComments}>
						<FontAwesome name="file-text-o" />
					</div>
					}
				</div>			
				{showExitButton && <div className="player-show-mode-toolbar-close-button" onClick={this.onClickClose}>
					<FontAwesome name="window-close" />
				</div>}
			</div>
		);
	}
}

ActivityPlayerShowModeToolbar.contextTypes = {
	tree: PropTypes.baobab
};

export default branch({
	user: ["user"],
	persistenceType: ["appState","targetConfig","type"],
	navStack: ["player", "navStack"]
}, ActivityPlayerShowModeToolbar);